import Invoices from './Invoices';

/**
 * InvoiceTracker — thin wrapper that renders the Invoices page in
 * "tracker" mode. Lives at /invoices/tracker (default landing tab
 * under the Invoices section). The actual table + inline status
 * dropdown is implemented inside Invoices.jsx; this file exists so
 * App.jsx routes have a clean per-tab component to point at.
 */
export default function InvoiceTracker() {
  return <Invoices view="tracker" />;
}
